import React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

const CollectionLanding = () => (
  <Box sx={{ backgroundColor: 'secondary.main', display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '60vh' }}>
    <Typography variant="h1" color="white">itau - /app/sales/collection-landing/landing-info</Typography>
  </Box>
);

export default CollectionLanding;
